import { Theme, ThemeEnum, ThemedCss } from '@/types/theme';

export const toCssVariables = (theme?: Theme): ThemedCss =>
  theme
    ? Object.keys(theme).reduce((v, k) => {
        (v as any)[ThemeEnum[k.replace(/^\w/, (c) => c.toUpperCase()) as any]] = (theme as any)[k];
        return v;
      }, {})
    : ({} as any);
